import MetricBase from "models/metrics/MetricBase";
import PerformanceGroup from "models/groups/PerformanceGroup";
import CurrencyUnit from "models/metrics/unit/CurrencyUnit";
import i18n from "i18next";

class MetricSpentBing extends MetricBase {
    constructor() {
        super({
            field: "metric_spent",
            defaultVisibility: true,
            unit: new CurrencyUnit(),
            chartName: i18n.t("metrics.bing-hotel-ads.spent.chartName"),
            serieLabel: i18n.t("metrics.bing-hotel-ads.spent.serieLabel"),
            tooltip: i18n.t("metrics.bing-hotel-ads.spent.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricSpentBing;
